import {useId} from 'react';
import {PopupHint} from '@prtimes-basis/popup-hint';
import {HintIcon} from '@prtimes-basis/icons';
import {Button} from '@prtimes-basis/button';
import {FormRow} from '../form-row';
import {billingInfoFields} from '../../fields/billing-info';
import styles from './billing-information-section.module.css';
import {FieldDescription} from '@/features/company-registration/steps/input-step/form-field/field-description';
import companyRegistrationPageStyles from '@/features/company-registration/styles.module.css';
import {useCompanyRegistrationFormContext} from '@/features/company-registration/form';

export function BillingInformationSection() {
  const id = useId();
  const formTitleId = `${id}-formTitle`;
  const copyButtonDescriptionId = `${id}-copyButtonDescription`;
  const form = useCompanyRegistrationFormContext();
  const onClickCopy = () => {
    form.setValue(
      'billingInfo.companyName',
      form.getValues('companyInfo.corporateName'),
    );
    form.setValue('billingInfo.zip', form.getValues('companyInfo.zip'));
    form.setValue('billingInfo.address', form.getValues('companyInfo.address'));
    form.setValue(
      'billingInfo.address2',
      form.getValues('companyInfo.address2'),
    );
    form.setValue(
      'billingInfo.department',
      form.getValues('contactPersonInfo.department'),
    );
    form.setValue(
      'billingInfo.lastName',
      form.getValues('contactPersonInfo.lastName'),
    );
    form.setValue(
      'billingInfo.firstName',
      form.getValues('contactPersonInfo.firstName'),
    );
    form.setValue(
      'billingInfo.lastNameKana',
      form.getValues('contactPersonInfo.lastNameKana'),
    );
    form.setValue(
      'billingInfo.firstNameKana',
      form.getValues('contactPersonInfo.firstNameKana'),
    );
    form.setValue(
      'billingInfo.email',
      form.getValues('contactPersonInfo.email'),
    );
  };

  return (
    <section aria-labelledby={formTitleId} className={styles.container}>
      <div className={companyRegistrationPageStyles.header}>
        <h2
          className={companyRegistrationPageStyles.formTitle}
          id={formTitleId}
        >
          請求情報
        </h2>

        <PopupHint
          content='配信料金をお支払いいただく会社（請求書の送付先）の情報をご記入ください。'
          wrapperClassName={companyRegistrationPageStyles.popupHintOverride}
          defaultPosition={{vertical: 'top', horizontal: 'right'}}
        >
          <span className={companyRegistrationPageStyles.popupHintText}>
            代理店の方へ
          </span>
          <HintIcon variant='colored' />
        </PopupHint>
      </div>

      <div className={styles.copyButtonContainer}>
        <Button
          variant='flat'
          aria-describedby={copyButtonDescriptionId}
          onClick={onClickCopy}
        >
          コピーする
        </Button>
        <FieldDescription id={copyButtonDescriptionId}>
          クリックすると、上でご入力いただいた企業情報の内容が請求情報にコピーされます。
        </FieldDescription>
      </div>

      <div className={companyRegistrationPageStyles.rows}>
        <FormRow
          isRequired
          labelText='会社名'
          htmlFor='billingInfo.companyName'
        >
          <billingInfoFields.companyNameField />
        </FormRow>

        <FormRow isRequired labelText='請求先住所'>
          <billingInfoFields.addressField />
        </FormRow>

        <FormRow labelText='所属部署' htmlFor='billingInfo.department'>
          <billingInfoFields.departmentField />
        </FormRow>

        <FormRow isRequired labelText='氏名'>
          <billingInfoFields.nameField />
        </FormRow>

        <FormRow isRequired labelText='氏名（カナ）'>
          <billingInfoFields.nameKanaField />
        </FormRow>

        <FormRow
          isRequired
          labelText='メールアドレス'
          htmlFor='billingInfo.email'
        >
          <billingInfoFields.emailField />
        </FormRow>

        <FormRow labelText='メールアドレス（cc）' htmlFor='billingInfo.emailCc'>
          <billingInfoFields.emailCcField />
        </FormRow>
      </div>
    </section>
  );
}
